import {
    ExtractionResult,
    ExtractionSelector,
} from './functions.interface';
import { ISettings } from './settings.interface';
import { Observable } from 'rxjs';
import { STATE_KEYS } from '../enums';

export interface IStateObserver<T> {
    stateObservable<S extends ExtractionSelector<T>>(prop: S): Observable<ExtractionResult<T, S>>;
}

export interface IStateManager<T> extends IStateObserver<T> {
    save<K extends keyof T>(key: K, value: T[K]): void;
}

export type IStateManagerService = IStateManager<IStateObject>;

//type can be explicitly set as: ReadonlyArray<keyof ISettings>
//but it allows to have subset of keys
//so i need type check const in test.ts: Expect<Equal<typeof SETTINGS_KEYS[number], keyof ISettings>>,
export const SETTINGS_KEYS = [
    'selectedClientId',
    'pads',
    'selectedRightBarIdx',
    'tradingLayoutHeight',
    'readNotifications',
    'clickMode',
    'tradingEnabled',
    'spotColumnState',
    'forwardColumnState',
    'pendingColumnState',
    'kondorColumnState',
    'positionColumnState',
    'spotFilterModel',
    'forwardFilterModel',
    'pendingFilterModel',
    'isColumnFilteringEnabled',
    'blotterSearchFilter',
    'blotterSelectedTab',
    'selectedNotificationFilter',
    'selectedSetting',
    'tradingQuantities',
    'selectedLimit',
] as const;

export type IStateObject = Pick<ISettings, typeof STATE_KEYS[number]>;
